module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/eWbCyR/tc-custom/9781911591214.jpg?1726519109880",
      "alt": "This image is the cover for the book Erin's Child, The Feeney Family Sagas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Erin's Child, The Feeney Family Sagas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A struggling Irish family in nineteenth century England sets its hopes on a new generation in the third volume of this dramatic historical saga.")])]), _c('p', [_c('i', [_vm._v("England, 1875")]), _vm._v(". The Feeney family has finally escaped the squalid slums of York. Though they have worked hard to rise up from poverty, they have not left hardship behind. The father Patrick remains a man of simple tastes, increasingly out of touch with his wife Thomasin’s ambition to expand her business empire across Yorkshire. ")]), _c('p', [_vm._v(" After losing their son, the Feeneys’ hopes for the family’s future now lie with their grandchildren. There is Rosanne, set to follow a rebel lover down a star-crossed road, and Erin’s daughter Belle, gifted and headstrong but born with a disability. ")]), _c('p', [_c('i', [_vm._v("The family has faces many challenges before, but what happens next will test them all.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sheelagh Kelly\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0